import React from 'react';

type Props = {};

const SellerAvatarSvg = (props: Props) => {
  return (
    <svg width='24' height='26' viewBox='0 0 24 26' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M1.33203 25C1.33203 25 1.33203 17 11.9987 17C22.6654 17 22.6654 25 22.6654 25M17.332 6.33333C17.332 9.27885 14.9442 11.6667 11.9987 11.6667C9.05318 11.6667 6.66536 9.27885 6.66536 6.33333C6.66536 3.38781 9.05318 1 11.9987 1C14.9442 1 17.332 3.38781 17.332 6.33333Z'
        stroke='#9DA0A9'
        strokeWidth='2'
        strokeLinecap='round'
      />
    </svg>
  );
};

export default SellerAvatarSvg;
